"use strict";

define('view/role.dropdown.view',['require','exports','module','underscore','../templates','uikit/elements/dropdown'],function (require, exports, module) {
  var _ = require('underscore'),
    Templates = require('../templates'),
    Dropdown = require('uikit/elements/dropdown');
  var FavoriteRoleButtonItem = Dropdown.ItemView.extend({
    template: Templates.IRB['dropdown.button'],
    options: _.extend({}, Dropdown.ItemView.prototype.options, {
      buttonIcon: 'star',
      favoriteRole: false
    }),
    ui: {
      iconButton: '.dropdown-button-icon'
    },
    events: {
      'click .dropdown-button-icon': 'setFavoriteRole'
    },
    initialize: function initialize() {
      Dropdown.ItemView.prototype.initialize.apply(this, arguments);
      this.on('before:render change:favoriteRole', this.setItemARIALabel);
      this.listenTo(app.channel, 'roleFavoriteChoice', function (choice) {
        if (choice && choice.get('displayName') === this.text) {
          this.favoriteRole = true;
        }
      });
    },
    setFavoriteRole: function setFavoriteRole(ev) {
      ev.stopPropagation();
      this.favoriteRole = true;
      app.request('setRoleFavorite', this.model);
    },
    setItemARIALabel: function setItemARIALabel(itemView) {
      var labelString = itemView.model.get('favoriteRole') ? 'current favorite: ' + itemView.model.get('displayName') : itemView.model.get('displayName') + ', use command-shift-enter to select as favorite';
      itemView.updateElementAttributes({
        'aria-label': labelString
      });
    }
  });
  var RoleDropdown = Dropdown.extend({
    attributes: _.extend({}, Dropdown.prototype.attributes, {
      role: 'menuitem'
    }),
    events: _.extend({}, Dropdown.prototype.events, {
      'keydown': 'handleRoleDropdownKeydown'
    }),
    initialize: function initialize() {
      Dropdown.prototype.initialize.apply(this, arguments);
      this.labelledby = this.cid + 'Header ' + this.cid + 'Text';
    },
    getChildView: function getChildView() {
      return FavoriteRoleButtonItem;
    },
    getCurrentlySelectedView: function getCurrentlySelectedView() {
      var menuItems = _.values(this.children._views);
      var menuItemDOMElements = _.map(menuItems, function (menuItem) {
        return menuItem.el;
      });
      var $currentlySelected = this.ui.menu.find('.selected');
      var currentIndex = menuItemDOMElements.indexOf($currentlySelected.get(0));
      return currentIndex !== -1 ? menuItems[currentIndex] : null;
    },
    handleRoleDropdownKeydown: function handleRoleDropdownKeydown(ev) {
      if (ev.metaKey && ev.shiftKey && ev.keyCode === 13) {
        var selectedView = this.getCurrentlySelectedView();
        if (_.isNull(selectedView) || selectedView.model.get('favoriteRole')) {
          return;
        }
        selectedView.setFavoriteRole(ev);
      } else {
        this.handleKeydown(ev);
      }
    }
  });
  RoleDropdown.Item = FavoriteRoleButtonItem;
  module.exports = RoleDropdown;
});

